import apiPath from '../../../config/api';

const LossesPath = {
    title: "Toko Teknik - Modul Kerugian",
    basePath: "/technique/kerugian",
    newPath: "/technique/kerugian/baru",
    detailPath: "/technique/kerugian/opsi/:id",
    base: apiPath.retailLosses,
    gnsFind: apiPath.masterGnsFind,
    gnsNmFilter: apiPath.masterGnsNmFilter,
    gnsCodeFilter: apiPath.masterGnsCodeFilter,
    gns: apiPath.masterGns,
    unitFilter: apiPath.masterUnitFilter,
    unit: apiPath.masterUnit
}

export default LossesPath;
